import { View, Text, Pressable, Image } from 'react-native'
import React, { FunctionComponent } from 'react'
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons'

import { ProfilSignatureProps } from './Profil.types'
import { useProfilStyles } from './Profil.styles'

import { DocumentPicker } from '../../components/DocumentPicker';

import { stdCouleurBleu } from '@commonStyle';

export const ProfilSignature: FunctionComponent<ProfilSignatureProps> = ({
  signatureUri,
  signatureUploadDate,
  selectedSignatureDocument,
  onFilePicked,
  onRemove,
  onDownload,
  onDraw,
}) => {
  const { styles } = useProfilStyles();

  return (
    <View style={styles.itemContainer}>
      <View style={styles.itemHeader}>
        <View style={styles.iconContainer}>
          <MaterialCommunityIcons name="pencil" color={stdCouleurBleu} size={30} />
        </View>
        <Text style={styles.label}>Signature</Text>
      </View>
      <View style={styles.itemContent}>
        {/* Document signature existant */}
        {signatureUri && !selectedSignatureDocument ? (
          <>
            <View style={{ alignItems: 'center', marginBottom: 10 }}>
              <Image source={{ uri: signatureUri }} style={styles.signaturePreview} resizeMode="contain" />
            </View>
            <View style={styles.documentInfoContainer}>
              <View style={styles.documentInfoContent}>
                <MaterialCommunityIcons name="file-document" size={25} color="#3b82f6" />
                <View style={styles.documentInfoText}>
                  <Text style={styles.documentFileName}>Signature</Text>
                  <Text style={styles.documentFileInfo}>
                    {signatureUploadDate && `Enregistrée le ${signatureUploadDate}`}
                  </Text>
                </View>
              </View>
              <View style={styles.documentActions}>
                <Pressable onPress={onDownload} style={styles.documentActionButton} testID='BT_DOWNLOAD_SIG'>
                  <MaterialCommunityIcons name="download" size={20} color="#3b82f6" />
                </Pressable>
                <Pressable onPress={onRemove} style={styles.documentActionButton} testID='BT_DELETE_PJ_SIG'>
                  <MaterialCommunityIcons name="delete" size={20} color="#ef4444" />
                </Pressable>
              </View>
            </View>
          </>
        ) : null}

        {/* Nouveau document sélectionné */}
        {selectedSignatureDocument && (
          <View style={styles.documentInfoContainer}>
            <View style={styles.documentInfoContent}>
              <MaterialCommunityIcons name="file-plus" size={25} color="#10b981" />
              <View style={styles.documentInfoText}>
                <Text style={styles.documentFileName}>{selectedSignatureDocument.filename || 'Nouveau document'}</Text>
                <Text style={styles.documentFileInfo}>{selectedSignatureDocument.size ? `${Math.round(selectedSignatureDocument.size / 1024)} KB • Nouveau` : 'Nouveau'}</Text>
              </View>
            </View>
            <Pressable onPress={onRemove} style={styles.documentActionButton} testID='BT_DELETE_PJ_SIG'>
              <MaterialCommunityIcons name="close" size={20} color="#6b7280" />
            </Pressable>
          </View>
        )}

        {!signatureUri && !selectedSignatureDocument && (
          <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
            <DocumentPicker acceptedTypes={['image/*']} onFilePicked={onFilePicked} onError={(e) => console.warn(e)} multiple={false} testID='DP_SIG_IMPORT'>
              <View style={styles.fichierButton} testID='BT_SIG_IMPORT'>
                <MaterialCommunityIcons name="folder-image" size={25} color="#3b82f6" />
                <Text style={styles.fichierText}>Importer une image</Text>
              </View>
            </DocumentPicker>
            <Pressable onPress={onDraw} style={[styles.fichierButton, { marginLeft: 12 }]} testID='BT_SIG_DRAW'>
              <MaterialCommunityIcons name="pencil" size={22} color="#3b82f6" />
              <Text style={[styles.fichierText, { marginLeft: 8 }]}>Dessiner</Text>
            </Pressable>
          </View>
        )}
      </View>
    </View>
  );
};
